import Tsa, {
  getServerSideProps as hgetServerSideProps,
} from '@pages/myapp/airport-security-wait-times/[market]';
import { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = hgetServerSideProps;

export default Tsa;
